import { ref } from 'vue';
import { PostModel } from '../models/post.model';
import { postService } from '../services/api/post.service';

export function usePosts() {
  const posts = ref<PostModel[]>([]);
  const isBookmarking = ref(false);

  const assignPosts = (newPosts: PostModel[]) => {
    posts.value = newPosts;
  };

  const toggleBookmark = async (post: PostModel) => {
    if (isBookmarking.value) {
      return;
    }

    try {
      isBookmarking.value = true;

      if (post.isBookmarked) {
        await postService.unbookmark(post.id);
        post.isBookmarked = false;
      } else {
        await postService.bookmark(post.id);
        post.isBookmarked = true;
      }
    } finally {
      isBookmarking.value = false;
    }
  };

  return {
    posts,
    isBookmarking,
    assignPosts,
    toggleBookmark,
  };
}
